/* eslint-disable no-param-reassign */
/* eslint-disable no-else-return */

/* eslint-disable max-len */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import Fetch, { V1 } from 'Util/fetcher';

const ON_REQUEST_LIST_NOTIFICATION = 'ON_REQUEST_LIST_NOTIFICATION';
const ON_REQUEST_LIST_NOTIFICATION_SUCCESS = 'ON_REQUEST_LIST_NOTIFICATION_SUCCESS';
const ON_REQUEST_LIST_NOTIFICATION_FAILURE = 'ON_REQUEST_LIST_NOTIFICATION_FAILURE';

function onRequestListNotification(resetData) {
  return {
    type: ON_REQUEST_LIST_NOTIFICATION,
    meta: { resetData },
  };
}

function onRequestListNotificationSuccess(payload) {
  return {
    type: ON_REQUEST_LIST_NOTIFICATION_SUCCESS,
    payload,
  };
}

function onRequestListNotificationFailure(payload) {
  return {
    type: ON_REQUEST_LIST_NOTIFICATION_FAILURE,
    payload,
  };
}

export const onDoRequestListNotification =
  (payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestListNotification(resetData));
    Fetch.get(`${V1}notification/user/history/${payload}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestListNotificationSuccess(resp.json));
        } else {
          dispatch(onRequestListNotificationFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestListNotificationFailure(error.message));
      });
  };

const ON_REQUEST_UNREAD_NOTIFICATION = 'ON_REQUEST_UNREAD_NOTIFICATION';
const ON_REQUEST_UNREAD_NOTIFICATION_SUCCESS = 'ON_REQUEST_UNREAD_NOTIFICATION_SUCCESS';
const ON_REQUEST_UNREAD_NOTIFICATION_FAILURE = 'ON_REQUEST_UNREAD_NOTIFICATION_FAILURE';

function onRequestUnreadNotification() {
  return {
    type: ON_REQUEST_UNREAD_NOTIFICATION,
  };
}

function onRequestUnreadNotificationSuccess(payload) {
  return {
    type: ON_REQUEST_UNREAD_NOTIFICATION_SUCCESS,
    payload,
  };
}

function onRequestUnreadNotificationFailure(payload) {
  return {
    type: ON_REQUEST_UNREAD_NOTIFICATION_FAILURE,
    payload,
  };
}

export const onDoRequestUnreadNotification = () => (dispatch) => {
  dispatch(onRequestUnreadNotification());
  Fetch.get(`${V1}notification/user/unread/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestUnreadNotificationSuccess(resp.json));
      } else {
        dispatch(onRequestUnreadNotificationFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestUnreadNotificationFailure(error.message));
    });
};

const ON_REQUEST_READ_NOTIFICATION = 'ON_REQUEST_READ_NOTIFICATION';
const ON_REQUEST_READ_NOTIFICATION_FAILURE = 'ON_REQUEST_READ_NOTIFICATION_FAILURE';
const ON_REQUEST_READ_NOTIFICATION_SUCCESS = 'ON_REQUEST_READ_NOTIFICATION_SUCCESS';

function onRequestReadNotification() {
  return {
    type: ON_REQUEST_READ_NOTIFICATION,
  };
}

function onRequestReadNotificationSuccess(payload) {
  return {
    type: ON_REQUEST_READ_NOTIFICATION_SUCCESS,
    payload,
  };
}

function onRequestReadNotificationFailure(payload) {
  return {
    type: ON_REQUEST_READ_NOTIFICATION_FAILURE,
    payload,
  };
}

export const onDoRequestReadNotification = () => (dispatch) => {
  dispatch(onRequestReadNotification());
  Fetch.get(`${V1}notification/user/read-all/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestReadNotificationSuccess(resp.json));
        dispatch(onDoRequestUnreadNotification());
      } else {
        dispatch(onRequestReadNotificationFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestReadNotificationFailure(error.message));
    });
};

const ON_DO_REQUEST_LIST_PROMO = 'ON_DO_REQUEST_LIST_PROMO';
const ON_DO_REQUEST_LIST_PROMO_FAILURE = 'ON_DO_REQUEST_LIST_PROMO_FAILURE';
const ON_DO_REQUEST_LIST_PROMO_SUCCESS = 'ON_DO_REQUEST_LIST_PROMO_SUCCESS';

function onRequestListPromo() {
  return {
    type: ON_DO_REQUEST_LIST_PROMO,
  };
}

function onRequestListPromoFailure(payload) {
  return {
    type: ON_DO_REQUEST_LIST_PROMO_FAILURE,
    payload,
  };
}

function onRequestListPromoSuccess(payload) {
  return {
    type: ON_DO_REQUEST_LIST_PROMO_SUCCESS,
    payload,
  };
}

export const onDoRequestListPromo = () => (dispatch) => {
  dispatch(onRequestListPromo());
  Fetch.get(`${V1}common/promo/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestListPromoSuccess(resp.json));
      } else {
        dispatch(onRequestListPromoFailure(resp.json));
      }
    })
    .catch((err) => {
      dispatch(onRequestListPromoFailure(err.message));
    });
};

const ON_DO_REQUEST_LIST_CTA = 'ON_DO_REQUEST_LIST_CTA';
const ON_DO_REQUEST_LIST_CTA_FAILURE = 'ON_DO_REQUEST_LIST_CTA_FAILURE';
const ON_DO_REQUEST_LIST_CTA_SUCCESS = 'ON_DO_REQUEST_LIST_CTA_SUCCESS';

function onRequestListCta() {
  return {
    type: ON_DO_REQUEST_LIST_CTA,
  };
}

function onRequestListCtaFailure(payload) {
  return {
    type: ON_DO_REQUEST_LIST_CTA_FAILURE,
    payload,
  };
}

function onRequestListCtaSuccess(payload) {
  return {
    type: ON_DO_REQUEST_LIST_CTA_SUCCESS,
    payload,
  };
}

export const onDoRequestListCta = () => (dispatch) => {
  dispatch(onRequestListCta());
  Fetch.get(`${V1}users/cta/`)
    .then((resp) => {
      if (resp.ok) {
        const filteredCTA = resp.json.length
          ? resp.json.filter((cta) => cta.web_action)
          : resp.json;
        dispatch(onRequestListCtaSuccess(filteredCTA));
      } else {
        dispatch(onRequestListCtaFailure(resp.json));
      }
    })
    .catch((err) => {
      dispatch(onRequestListCtaSuccess(err.message));
    });
};

const INITIAL_STATE = {
  listNotificationLoading: null,
  listNotificationError: null,
  listNotificationData: null,

  unreadNotifLoading: null,
  unreadNotifError: null,
  unreadNotifData: null,

  readNotifLoading: false,
  readNotifData: null,
  readNotifError: null,

  listPromoData: null,
  listPromoLoading: false,
  listPromoError: false,

  listCtaData: null,
  listCtaLoading: false,
  listCtaError: false,
};
const notification = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_LIST_NOTIFICATION:
      if (action.meta.resetData) {
        return {
          ...state,
          listNotificationLoading: true,
          listNotificationData: null,
          listNotificationError: null,
        };
      } else {
        return {
          ...state,
          listNotificationLoading: true,
          listNotificationError: null,
        };
      }
    case ON_REQUEST_LIST_NOTIFICATION_SUCCESS:
      if (state.listNotificationData) {
        const oldResults = [...state.listNotificationData.result.results];
        state.listNotificationData = {
          ...action.payload,
          result: {
            ...action.payload.result,
            results: [...oldResults, ...action.payload.result.results],
          },
        };
      } else {
        state.listNotificationData = action.payload;
      }
      return {
        ...state,
        listNotificationLoading: false,
        listNotificationError: null,
      };
    case ON_REQUEST_LIST_NOTIFICATION_FAILURE:
      return {
        ...state,
        listNotificationLoading: false,
        listNotificationError: action.payload,
      };

    case ON_REQUEST_UNREAD_NOTIFICATION:
      return {
        ...state,
        unreadNotifLoading: true,
        unreadNotifData: null,
        unreadNotifError: null,
      };
    case ON_REQUEST_UNREAD_NOTIFICATION_SUCCESS:
      return {
        ...state,
        unreadNotifLoading: false,
        unreadNotifData: action.payload,
        unreadNotifError: null,
      };
    case ON_REQUEST_UNREAD_NOTIFICATION_FAILURE:
      return {
        ...state,
        unreadNotifLoading: false,
        unreadNotifData: null,
        unreadNotifError: action.payload,
      };

    case ON_REQUEST_READ_NOTIFICATION:
      return {
        ...state,
        readNotifLoading: true,
        readNotifData: null,
        readNotifError: null,
      };
    case ON_REQUEST_READ_NOTIFICATION_SUCCESS:
      return {
        ...state,
        readNotifLoading: false,
        readNotifData: action.payload,
        readNotifError: null,
      };
    case ON_REQUEST_READ_NOTIFICATION_FAILURE:
      return {
        ...state,
        readNotifLoading: false,
        readNotifData: null,
        readNotifError: action.payload,
      };

    case ON_DO_REQUEST_LIST_PROMO:
      return {
        ...state,
        listPromoLoading: true,
        listPromoData: null,
        listPromoError: null,
      };
    case ON_DO_REQUEST_LIST_PROMO_FAILURE:
      return {
        ...state,
        listPromoLoading: false,
        listPromoData: null,
        listPromoError: action.payload,
      };
    case ON_DO_REQUEST_LIST_PROMO_SUCCESS:
      return {
        ...state,
        listPromoLoading: false,
        listPromoData: action.payload,
        listPromoError: null,
      };

    case ON_DO_REQUEST_LIST_CTA:
      return {
        ...state,
        listCtaLoading: true,
        listCtaData: null,
        listCtaError: null,
      };
    case ON_DO_REQUEST_LIST_CTA_FAILURE:
      return {
        ...state,
        listCtaLoading: false,
        listCtaData: null,
        listCtaError: action.payload,
      };
    case ON_DO_REQUEST_LIST_CTA_SUCCESS:
      return {
        ...state,
        listCtaLoading: false,
        listCtaData: action.payload,
        listCtaError: null,
      };

    default:
      return state;
  }
};
export default notification;
